export const pizzaRed = "#d32f2f";   // Original #f44336
export const corianderGreen = "#27ae60";   // Original #f44336
export const pomegranateRed = "#e74c3c";
